import { DESCRIPTION_COPY_LIMITS, TITLE_COPY_LIMITS } from "../copy-policy";
export const PLAYGROUND_VIDEO_TARGET = {
    width: 1280,
    height: 720,
    aspectRatio: "16:9",
};
export const playgroundVideoSchema = {
    componentId: "PlaygroundVideo",
    scalarSlots: [
        { key: "heading", ...TITLE_COPY_LIMITS, label: "Heading", type: "text" },
        {
            key: "subheading",
            ...DESCRIPTION_COPY_LIMITS,
            label: "Subheading",
            type: "textarea",
        },
    ],
    mediaSlots: [
        {
            key: "media",
            label: "Media",
            // The declaration under test: this slot takes either kind. Its
            // pictures-only counterpart is PlaygroundCard's icon slot, which says
            // nothing and therefore takes pictures — the default doing the work.
            accepts: ["image", "video"],
            targets: [{ ...PLAYGROUND_VIDEO_TARGET }],
        },
    ],
};
//# sourceMappingURL=playground-video.js.map